import { Reveal } from "../Reveal";
import { ArrowUpRight } from "lucide-react";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#09090b] py-24 lg:py-36 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <div className="relative">
            <div className="overflow-hidden rounded-3xl">
              <img
                src="/mpm/work3.jpg"
                alt="Fraser River marine operations"
                className="w-full h-[420px] lg:h-[560px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 sm:right-6 bg-[#e85d04] text-white rounded-2xl px-7 py-5 shadow-2xl">
              <p className="font-display text-3xl font-extrabold leading-none">Est. 2017</p>
              <p className="text-xs font-semibold tracking-[0.2em] uppercase mt-1">Ladner, BC</p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <span className="text-[#e85d04] text-xs font-bold tracking-[0.28em] uppercase">
              About Mad Props
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-5">
              A family crew.
              <br />
              These waters,
              <br />
              our trade.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-lg text-white/65 font-light leading-relaxed max-w-lg">
              Mad Props Marine is a Ladner, BC company built on timely, safe and
              honest service. From emergency and disaster response to towing,
              diving, recovery and salvage — we do the awkward, difficult and
              challenging work most won't touch.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-5 text-lg text-[#e85d04] font-medium">
              Yes we can. No such thing as can't.
            </p>
          </Reveal>
          <Reveal delay={0.4}>
            <div className="mt-10 flex flex-wrap gap-8">
              {["Ready", "Willing", "Capable"].map((w) => (
                <div key={w} className="flex items-center gap-2 text-white/80">
                  <ArrowUpRight size={18} className="text-[#e85d04]" />
                  <span className="font-display font-semibold text-lg">{w}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
